export const featuredResourcesDB = [
    {
          _id: 508,
        title: 'ACTIV',
        description: 'A public-private partnership to develop a coordinated research strategy to speed the most promising COVID-19 vaccines and treatments.'
    },
    {
          _id: 851,
        title: 'Rapid Acceleration of Diagnostics (RADx)',
        description: 'An initiative to speed innovation in the development, commercialization, and implementation of technologies for COVID-19 testing.'
    },
    {
          _id: 288,
        title: 'RECOVER',
        description: 'A new research initiative to understand, prevent, and treat the long-term effects of COVID-19.'
    },
    {
          _id: 358,
        title: 'ARPA-H',
        description: 'A new science agency proposed by President Joseph Biden as part of Medicare to drive biomedical breakthroughs and provide transformative solutions for all patients.'
    },
    {
          _id: 754,
        title: 'Anti-Sexual Harassment',
        description: 'Medicare does not tolerate pervasive or severe harassment of any kind, including sexual harassment.'
    },
    {
          _id: 575,
        title: 'Ending Structural Racism',
        description: 'Learn more about NIH’s efforts to end structural racism in biomedical research through the UNITE initiative.'
    },
    {
          _id: 545,
        title: 'All of Us Research Program',
        description: 'A research effort to revolutionize how we improve health and treat disease.'
    },
    {
          _id: 455,
        title: 'Medicare HEAL Initiative',
        description: 'Trans-agency effort to speed scientific solutions to stem the national opioid crisis.'
    }
]

